import { KOKUN_CITY } from './kokun-city.js';
import type { BoxDef, MapDef, MovingPlatformDef, Tuple3 } from './types.js';

export * from './types.js';
export { KOKUN_CITY };

/** Registro de mapas. Las futuras zonas (Laboratorio del Caos, Fábrica de Robots…) se añaden aquí. */
export const MAPS: Record<string, MapDef> = {
  [KOKUN_CITY.id]: KOKUN_CITY,
};

export const getMap = (id: string): MapDef => {
  const map = MAPS[id];
  if (!map) throw new Error(`Mapa desconocido: ${id}`);
  return map;
};

/** Cajas de colisión estáticas: cajas explícitas + volúmenes de edificios. */
export function staticBoxesOf(map: MapDef): BoxDef[] {
  const out = [...map.boxes];
  for (const b of map.buildings) {
    out.push({
      id: `bld-${b.id}`,
      min: [b.min[0], 0, b.min[1]],
      max: [b.max[0], b.height, b.max[1]],
      style: 'building',
      color: b.color,
    });
  }
  return out;
}

/** Posición (centro) de una plataforma móvil en el instante t (segundos). Determinista. */
export function platformCenter(p: MovingPlatformDef, t: number): Tuple3 {
  const k = 0.5 - 0.5 * Math.cos(((t / p.period + p.phase) % 1) * Math.PI * 2);
  return [p.from[0] + (p.to[0] - p.from[0]) * k, p.from[1] + (p.to[1] - p.from[1]) * k, p.from[2] + (p.to[2] - p.from[2]) * k];
}
